<script>
    import { onMount, createEventDispatcher } from "svelte";
    import Quill from "quill";
    import AssetModal from "./assets/AssetModal.svelte";
    import { _ } from "svelte-i18n";
    import { getAssetURL } from "../common/assets";
    import ImageResize from "./image_resize/ImageResize";

    export let value;

    export let placeholder = "";
    export let toolbar = [
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        ["bold", "italic", "underline", "strike"],
        ["blockquote", "code-block"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ script: "sub" }, { script: "super" }],
        [{ indent: "-1" }, { indent: "+1" }],
        ["link", "image", "video", "formula"],
        [
            { color: ["none", "#4299e1", "#0047B2", "#CCE0F5"] },
            { background: ["none", "#4299e1", "#0047B2", "#CCE0F5"] },
        ],
        [{ align: [] }],
        ["clean"],
    ];

    let editor;
    let quill;

    let imageAssetOpened = false;

    const dispatch = createEventDispatcher();

    let noUpdate = false;

    onMount(async () => {
        Quill.register("modules/imageResize", ImageResize);
        quill = new Quill(editor, {
            theme: "snow",
            placeholder,
            modules: { toolbar, imageResize: {} },
        });

        const toolbarModule = quill.getModule("toolbar");
        toolbarModule.addHandler("image", () => {
            imageAssetOpened = true;
        });
        // let matches = (value + "").match(/[^\x00-\x7F]/g);
        // console.log(matches.map((v) => v.charCodeAt(0)));
        setText(value);
        updateValue();

        quill.on("text-change", function () {
            noUpdate = true;
            updateValue();
            dispatch("change", value);
        });
    });

    export const setText = (text) => {
        if (!quill) return;
        const delta = quill.clipboard.convert(
            (text || "").replace(/\uFEFF/, "")
        );
        quill.setContents(delta);
        value = text;
    };

    const updateValue = () => {
        value = quill.root.innerHTML;
    };

    const safeSetValue = (value) => {
        if (!noUpdate) setText(value);
        noUpdate = false;
    };

    $: safeSetValue(value);

    const handleImageAsset = ({ detail: asset }) => {
        try {
            quill.format("image", getAssetURL(asset));
        } catch (e) {}
        imageAssetOpened = false;
    };
</script>

{#if imageAssetOpened}
    <AssetModal
        bind:opened={imageAssetOpened}
        filter="image/*"
        on:asset={handleImageAsset}
        title={$_("ChoosePicture")} />
{/if}

<div class="editor-wrapper flex flex-col">
    <div bind:this={editor} />
</div>
